var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_830_242",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5995 11.4204C36.2258 11.0459 35.7185 10.8354 35.1895 10.8354C34.6604 10.8354 34.1531 11.0459 33.7795 11.4204L23.9995 21.1804L14.2195 11.4004C13.8458 11.0259 13.3385 10.8154 12.8095 10.8154C12.2804 10.8154 11.7731 11.0259 11.3995 11.4004C10.6195 12.1804 10.6195 13.4404 11.3995 14.2204L21.1795 24.0004L11.3995 33.7804C10.6195 34.5604 10.6195 35.8204 11.3995 36.6004C12.1795 37.3804 13.4395 37.3804 14.2195 36.6004L23.9995 26.8204L33.7795 36.6004C34.5595 37.3804 35.8195 37.3804 36.5995 36.6004C37.3795 35.8204 37.3795 34.5604 36.5995 33.7804L26.8195 24.0004L36.5995 14.2204C37.3595 13.4604 37.3595 12.1804 36.5995 11.4204Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_830_242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: "#043B3B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.3b4409819677948d0ee8272901798384.svg";
export { ForwardRef as ReactComponent };